<template>
  <div style="background-color: rgb(249,250,255);overflow-x: hidden">
    <NavHeader
      :status="{
        page:'produceVR',
        produce:true,
        solution:false
      }"
    />
    <div class="main">

      <div class="first-card">
        <div class="first-title"></div>
        <div class="first-back"></div>
        <div class="switch-btn-group">
          <div class="btn-1" @click="switchVR(1)">
            <div class="switch-btn-icon"></div>
            <div class="btn-text" :class="{'active-text':activeVR===1}">沉浸式VR</div>
            <div class="btn-underline" v-show="activeVR===1"></div>
          </div>
          <div class="btn-2" @click="switchVR(2)">
            <div class="switch-btn-icon2"></div>
            <div class="btn-text" :class="{'active-text':activeVR===2}">桌面式VR</div>
            <div class="btn-underline" v-show="activeVR===2"></div>
          </div>
        </div>
        <div class="card-1" :style="activeVR===2?{left:'-100vw'}:{}">
          <div class="card-1-back-1"></div>
          <div class="card-1-back-2"></div>
          <div class="card-1-back-3"></div>
          <div class="card-1-back-4"></div>
          <div class="card-1-back-5"></div>
          <div class="card-1-back-6"></div>
          <div class="card-1-card-right pic-1">
            <div class="card-text-area">
              <div class="flex-left" style="color: #5eb2f7">
                <div >·&nbsp;&nbsp;物理实验</div>
                <div >·&nbsp;&nbsp;化学实验</div>
              </div>
              <div class="flex-right" style="color: #5eb2f7">
                <div >·&nbsp;&nbsp;生物实验</div>
                <div >·&nbsp;&nbsp;科学实验</div>
              </div>
            </div>
            <div class="card-pic-1-right"><div class="pic-11"></div></div>
          </div>
          <div class="card-1-card-left pic-2" >
            <div class="card-text-area">
              <div class="flex-left" style="color: #c00000">
                <div >·&nbsp;&nbsp;党史馆</div>
                <div >·&nbsp;&nbsp;习近平重要讲话馆</div>
              </div>
              <div class="flex-right" style="color: #c00000">
                <div >·&nbsp;&nbsp;向扶贫工作者致敬</div>
                <div >·&nbsp;&nbsp;廉政馆</div>
              </div>

            </div>
            <div class="card-pic-2-left"><div class="pic-12"></div></div>
          </div>
          <div class="card-1-card-right pic-3">
            <div class="card-text-area">

              <div class="flex-left" style="color: #7dd181">
                <div >·&nbsp;&nbsp;校园火灾逃生</div>
                <div >·&nbsp;&nbsp;校园交通安全</div>
              </div>
              <div class="flex-right" style="color: #7dd181">
                <div >·&nbsp;&nbsp;校园地震逃生</div>
                <div >·&nbsp;&nbsp;宿舍隐患排查</div>
              </div>
            </div>
            <div class="card-pic-3-right"><div class="pic-13"></div></div>
          </div>
          <div class="card-1-card-left pic-4">
            <div class="card-text-area">

              <div class="flex-left" style="color: #f0cb72">
                <div >·&nbsp;&nbsp;送红军</div>
                <div >·&nbsp;&nbsp;平型关大捷</div>
              </div>
              <div class="flex-right" style="color: #f0cb72">
                <div >·&nbsp;&nbsp;抗日战争馆</div>
                <div >·&nbsp;&nbsp;一带一路文化馆</div>
              </div>
            </div>
            <div class="card-pic-4-left"><div class="pic-14"></div></div>
          </div>
          <div class="card-1-card-right pic-5">
            <div class="card-text-area">

              <div class="flex-left" style="color: #ba83f7">
                <div >·&nbsp;&nbsp;VR虚拟现实航空实训</div>
                <div >·&nbsp;&nbsp;传播分段建造VR方案</div>
              </div>
              <div class="flex-right" style="color: #ba83f7">
                <div >·&nbsp;&nbsp;矿山建设工程VR实训</div>
                <div >·&nbsp;&nbsp;采油工程三维虚拟实验教学</div>
              </div>
            </div>
            <div class="card-pic-5-right"><div class="pic-15"></div></div>
          </div>
        </div>
        <div class="card-2" :style="activeVR===2?{left:'0'}:{}">
          <div class="card-1-back-1"></div>
          <div class="card-1-back-2"></div>
          <div class="card-1-back-3"></div>
          <div class="card-1-back-4"></div>
          <div class="card-1-back-5"></div>
          <div class="card-1-back-6"></div>
          <div class="card-2-card-right pic-6">
            <div class="card-text-area">
              <div class="flex-left" style="color: #5eb2f7">
                <div >·&nbsp;&nbsp;地球与宇宙科学</div>
                <div >·&nbsp;&nbsp;生命科学</div>
              </div>
              <div class="flex-right" style="color: #5eb2f7">
                <div >·&nbsp;&nbsp;物质科学</div>
                <div >·&nbsp;&nbsp;技术与工程</div>
              </div>
            </div>
            <div class="card-pic-6-right"><div class="pic-16"></div></div>
          </div>
          <div class="card-2-card-left pic-7" >
            <div class="card-text-area">
              <div class="flex-left" style="color: #c00000">
                <div >·&nbsp;&nbsp;消化系统的组成和功能</div>
                <div >·&nbsp;&nbsp;神经系统的组成和功能</div>
              </div>
              <div class="flex-right" style="color: #c00000">
                <div >·&nbsp;&nbsp;心脏的结构和功能</div>
                <div >·&nbsp;&nbsp;血液循环的途径</div>
              </div>

            </div>
            <div class="card-pic-7-left"><div class="pic-17"></div></div>
          </div>
          <div class="card-2-card-right pic-8">
            <div class="card-text-area">

              <div class="flex-left" style="color: #7dd181">
                <div >·&nbsp;&nbsp;太阳探索</div>
                <div >·&nbsp;&nbsp;太空探索-地球轨道</div>
              </div>
              <div class="flex-right" style="color: #7dd181">
                <div >·&nbsp;&nbsp;月食和日食</div>
                <div >·&nbsp;&nbsp;我们的太阳系</div>
              </div>
            </div>
            <div class="card-pic-8-right"><div class="pic-18"></div></div>
          </div>
          <div class="card-2-card-left pic-9">
            <div class="card-text-area">

              <div class="flex-left" style="color: #f0cb72">
                <div >·&nbsp;&nbsp;物理实验</div>
                <div >·&nbsp;&nbsp;生物实验</div>
              </div>
              <div class="flex-right" style="color: #f0cb72">
                <div >·&nbsp;&nbsp;化学实验</div>
                <div >·&nbsp;&nbsp;小学科学</div>
              </div>
            </div>
            <div class="card-pic-9-left">
              <div class="pic-19"></div>
            </div>
          </div>
          <div class="card-2-card-right pic-10">
            <div class="card-text-area">

              <div class="flex-left" style="color: #ba83f7">
                <div >·&nbsp;&nbsp;VR虚拟现实航空实训</div>
                <div >·&nbsp;&nbsp;传播分段建造VR方案</div>
              </div>
              <div class="flex-right" style="color: #ba83f7">
                <div >·&nbsp;&nbsp;矿山建设工程VR实训</div>
                <div >·&nbsp;&nbsp;采油工程三维虚拟实验教学</div>
              </div>
            </div>
            <div class="card-pic-10-right">
              <div class="pic-20"></div>
            </div>
          </div>

        </div>
      </div>



      <div class="pic-switch">
        <el-carousel height="40vw" :autoplay="false" indicator-position="none" style="position: relative" ref="carousel">
          <div class="switch-btn-1" :class="{'active-btn':picIsFirst}" @click="$refs.carousel['setActiveItem'](0);picIsFirst=true">创新实验室</div>
          <div class="switch-btn-2" :class="{'active-btn':!picIsFirst}" @click="$refs.carousel['setActiveItem'](1);picIsFirst=false">虚拟仿真实验室</div>
          <el-carousel-item>
            <img src="http://data.xiyilab.com/web/main/static/解决方案/创新实验室banner.png" style="height:100%;width:100%;" alt="图片丢失了" />
          </el-carousel-item>
          <el-carousel-item>
            <img src="http://data.xiyilab.com/web/main/static/VR/虚拟仿真实验室.png" style="height:100%;width:100%;" alt="图片丢失了" />
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="second-card">
        <div class="second-title"></div>
        <div class="move-back-left"></div>
        <div class="move-back-right"></div>
        <div class="second-content">
          <div class="second-content-card">
            <div class="second-content-card-pic pic-21"></div>
            <div class="second-content-card-title">资源丰富</div>
            <div class="second-content-card-text">系统内置资源丰富，素材多样</div>
          </div>
          <div class="second-content-card">
            <div class="second-content-card-pic pic-22"></div>
            <div class="second-content-card-title">沉浸式教学</div>
            <div class="second-content-card-text">沉浸式教学体验使学习效果更佳，提升教学趣味性</div>
          </div>
          <div class="second-content-card">
            <div class="second-content-card-pic pic-23"></div>
            <div class="second-content-card-title">真实还原</div>
            <div class="second-content-card-text">真实还原现实场景，操作感、交互感更强</div>
          </div>
          <div class="second-content-card">
            <div class="second-content-card-pic pic-24"></div>
            <div class="second-content-card-title">无时空限制</div>
            <div class="second-content-card-text">不受时间和空间的限制，无论在何处都有真实的参与感</div>
          </div>
        </div>
      </div>

      <div class="third-card"></div>

      <div class="footer-img">
        <div style="font-family: test;font-size: 1.2vw;color: white;font-weight: 100;cursor: default">让我们一起育见未来</div>
        <div class="footer-btn-group">
          <div class="footer-btn">立即试用</div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import NavHeader from '@/components/NavHeader'
import Footer from '@/components/Footer'
import $ from 'jquery'
export default {
  name: 'producePhysical',
  components:{
    NavHeader,
    Footer
  },
  data(){
    return{
      activeLine:'line1',
      rightFlag:0,
      leftFlag:0,
      title:'电学',
      aboveCard:2,
      openDate:'',
      timer:null,
      timer1:null,
      activeVR:1,
      picIsFirst:true,
      text:'模拟真实的接线场景、还原真实器材、器材间自由连接，给实验提供更多可能性'
    }
  },
  mounted () {
    if (this.$route.query.way === 'desktop') {
      this.activeVR = 2
    } else {
      this.activeVR = 1
    }
    this.openDate=new Date()
    window.addEventListener('mousewheel',(e)=>{
      if($('.move-back-right')[0].getBoundingClientRect().top-window.innerHeight<=0&&this.leftFlag===0){
        $('.move-back-right').animate({
          right:'5vw'
        },500)
        this.leftFlag=1
      }
    })
  },
  methods:{
    switchVR(cardIndex){
      let now=new Date()
      if(now-this.openDate>500){
        if(cardIndex!==this.activeVR){
          if(cardIndex===1){
            $('.card-2').animate({
              left:'100vw'
            },500)
            $('.card-1').animate({
              left:'0'
            },500)
            this.activeVR=cardIndex
            this.openDate=now
          }
          else{
            $('.card-1').animate({
              left:'-100vw'
            },300)
            $('.card-2').animate({
              left:'0'
            },300)
            this.activeVR=cardIndex
            this.openDate=now
          }

        }
      }

    }
  }
}
</script>

<style scoped>
.header {
  position: relative;
  width: 100vw;
  height: 42vh;
  background-color: white
}
.main{
  margin-top: 21vw;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.first-card{
  width: 100vw;
  height: 168vw;
  position: relative;
  background-color: white;

}

.pic-switch{
  margin-top: 5vw;
  width: 100vw;
  height: 40vw;
}

.second-card{
  width: 100vw;
  height: 37vw;
  margin-top: 5vw;
  position: relative;
}
.second-title{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/特色优势.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 16.7vw;
  height: 6vw;
  margin: 3vw auto 0;
}
.move-back-left{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/椭圆5拷贝10.png");
  left: 10vw;
  top:2vw;
  z-index: 1;
  position: absolute;
  width: 20vw;
  height: 17.7vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  animation:float6 3s infinite;
  -webkit-animation:float6 3s infinite;
}
.move-back-right{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/细胞.png");
  right: -20vw;
  bottom:2vw;
  z-index: 1;
  position: absolute;
  width: 12vw;
  height: 10vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
@-webkit-keyframes float6 {
  0%{
    top:2vw
  }
  50%{
    top:1vw
  }
  100%{
    top:2vw
  }
}
@keyframes float6 {
  0%{
    top:2vw
  }
  50%{
    top:1vw
  }
  100%{
    top:2vw
  }
}

.second-content{
  position: absolute;
  width: 62vw;
  height: 15.625vw;
  margin : 5vw auto;
  left:19vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
}
.second-content-card{
  height: 100%;
  width: 12vw;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px
  rgba(160, 160, 160, 0.5);
  border-radius: 4px;
  border: solid 1px #f0f3fd;
  transition: all .5s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.second-content-card-pic{
  width: 4.68vw;
  height: 4.68vw;
  margin-bottom: 1vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.pic-21{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/物理特色1.png");
}
.pic-22{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/物理特色2.png");
}
.pic-23{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/物理特色3.png");
}
.pic-24{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/物理特色4.png");
}
.second-content-card-title{
  font-family:test;
  font-size: 1vw;
  font-weight: 600;
  font-stretch: normal;
  line-height: 2vw;
  letter-spacing: 2px;
  color: #3e3a39;
}

.second-content-card-text{
  width: 80%;
  text-align: center;
  font-family: test;
  font-size: 0.85vw;
  font-weight: 100;
  font-stretch: normal;
  line-height: 1.8vw;
  letter-spacing: 2px;
  color: #3e3a39;
}
.second-content-card:hover{
  transform: scale(1.2);
}
.third-card{
  width: 100vw;
  height: 66vw;
  background-image: url("http://data.xiyilab.com/web/main/static/VR/设备展示.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.first-title{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/课程体系.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 16.7vw;
  height: 6vw;
  margin: 3vw auto 0;
}
.first-back{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/装饰.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 100vw;
  height: 47.3vw;
  position: absolute;
  z-index: 1;
  top:0vw;
}
.switch-btn-group{
  width: 40vw;
  height: 13vw;
  position: absolute;
  top:12vw;
  left:30vw;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-end;
  z-index: 999;
}
.btn-1{
  width: 20vw;
  height: 12vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.switch-btn-icon{
  margin-top: 5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/VR/沉浸式VR.png");
  width: 5vw;
  height: 5vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.switch-btn-icon2{
  margin-top: 5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/VR/桌面式VR.png");
  width: 5vw;
  height: 5vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.btn-text{
  font-family: test;
  font-size: 1vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vw;
  letter-spacing: 2px;
  color: #3e3a39;
}
.active-text{
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%);
  -webkit-background-clip: text;
  color: transparent;
}
.btn-underline{
  width: 10vw;
  height: 2px;
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%),
  linear-gradient(
    #ffffff,
    #ffffff);
  background-blend-mode: normal,
  normal;
}
.btn-2{
  width: 20vw;
  height: 12vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btn-1:hover .btn-text{
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%);
  -webkit-background-clip: text;
  color: transparent;
}
.btn-2:hover .btn-text{
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%);
  -webkit-background-clip: text;
  color: transparent;
}
.card-1{
  width: 100vw;
  height: 145vw;
  position: absolute;
  top:25vw;
  left:0;
  background-color: rgb(249,250,255);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  z-index: 999;
}
.card-1-card-right{
  width: 60vw;
  height: 23.5vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
}
.card-2-card-right{
  width: 60vw;
  height: 23.5vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
}
.card-2-card-left{
  width: 60vw;
  height: 23.5vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
}
.card-2-card-right .card-text-area{
  width: 18vw;
  height: 3vw;
  position: absolute;
  left:3vw;
  bottom:7vw;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  font-size: 0.9vw;
  font-family: test;
  letter-spacing: 1px;
  text-align: left;
  white-space: nowrap;
}
.card-2-card-left .card-text-area{
  width: 18vw;
  height: 3vw;
  position: absolute;
  right:7vw;
  bottom:7vw;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  font-size: 0.9vw;
  font-family: test;
  letter-spacing: 1px;
  text-align: left;
  white-space: nowrap;
}
.card-1-card-right .card-text-area{
  width: 18vw;
  height: 3vw;
  position: absolute;
  left:3vw;
  bottom:7vw;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  font-size: 0.9vw;
  font-family: test;
  letter-spacing: 1px;
  text-align: left;
  white-space: nowrap;
}
.flex-left{
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: flex-start;
  justify-content: space-between;
}
.flex-right{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
.card-pic-1-right{
  overflow: hidden;
  width: 31.25vw;
  height:22vw ;
  top:2vw;
  right:0;
  position: absolute;
}
.card-pic-6-right{

  width: 31.25vw;
  height:22vw ;
  top:2vw;
  right:0;
  position: absolute;
  overflow: hidden;
}
.card-pic-8-right{

  width: 31.25vw;
  height:22vw ;
  top:2vw;
  right:0;
  position: absolute;
  overflow: hidden;
  transition: all .5s;
}
.card-pic-10-right{
  width: 31.25vw;
  height:22vw ;
  top:2vw;
  right:0;
  position: absolute;
  overflow: hidden;
  transition: all .5s;
}
.card-pic-10-right:hover .pic-20{
  transform: scale(1.2);
}
.card-pic-9-left:hover .pic-19{
  transform: scale(1.2);
}
.card-pic-8-right:hover .pic-18{
  transform: scale(1.2);
}
.card-pic-7-left:hover .pic-17{
  transform: scale(1.2);
}
.card-pic-6-right:hover .pic-16{
  transform: scale(1.2);
}
.card-pic-5-right:hover .pic-15{
  transform: scale(1.2);
}
.card-pic-4-left:hover .pic-14{
  transform: scale(1.2);
}
.card-pic-3-right:hover .pic-13{
  transform: scale(1.2);
}
.card-pic-2-left:hover .pic-12{
  transform: scale(1.2);
}
.card-pic-1-right:hover .pic-11{
  transform: scale(1.2);
}
.pic-11{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/VR课程tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}
.pic-12{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/党政建设tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}
.pic-13{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/校园安全tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}
.pic-14{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/红色教育tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}
.pic-15{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/定制化开发tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}
.pic-16{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/小学科学tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}
.pic-17{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/认识人体tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}
.pic-18{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/认识天体tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}
.pic-19{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/桌面VR课程tp.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .5s;
  width: 100%;
  height: 100%;
}


.pic-20{
  transition: all .5s;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/VR/定制化开发tp.png");
}
.pic-1{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/VR课程.png");
}
.pic-2{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/党政建设.png");
}
.pic-3{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/校园安全.png");
}
.pic-4{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/红色教育.png ");
}
.pic-5{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/定制化开发.png");
}
.pic-6{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/小学科学.png");
}
.pic-7{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/认识人体.png");
}
.pic-8{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/认识天体.png");
}
.pic-9{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/桌面VR课程.png");
}
.pic-10{
  background-image: url("http://data.xiyilab.com/web/main/static/VR/定制化开发.png");
}
.card-1-card-left{
  width: 60vw;
  height: 23.5vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
}
.card-1-card-left .card-text-area{
  width: 18vw;
  height: 3vw;
  position: absolute;
  right:7vw;
  bottom:7vw;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  font-size: 0.9vw;
  font-family: test;
  letter-spacing: 1px;
  text-align: left;
  white-space: nowrap;
}
.card-pic-2-left{

  width: 31.25vw;
  height:22vw ;
  top:2vw;
  left:0;
  position: absolute;
  overflow: hidden;
}
.card-pic-7-left{

  width: 31.25vw;
  height:22vw ;
  top:2vw;
  left:0;
  position: absolute;
  overflow: hidden;
}
.card-pic-9-left{

  width: 31.25vw;
  height:22vw ;
  top:2vw;
  left:0;
  position: absolute;
  overflow: hidden;
}
.card-pic-3-right{
  overflow: hidden;
  width: 31.25vw;
  height:22vw ;
  top:2vw;
  right:0;
  position: absolute;
}
.card-pic-4-left{
  overflow: hidden;
  width: 31.25vw;
  height:22vw ;
  top:2vw;
  left:0;
  position: absolute;
}
.card-pic-5-right{
  overflow: hidden;
  width: 31.25vw;
  height:22vw ;
  top:2vw;
  right:0;
  position: absolute;
}

.card-2{
  width: 100vw;
  height: 145vw;
  position: absolute;
  top:25vw;
  left:100vw;
  background-color: rgb(249,250,255);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  z-index: 999;
}
.card-1-back-1{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/物理模考装饰背景左侧.png");
  width: 23vw;
  height: 21vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  top:35vw;
  left: 6vw;
  -webkit-animation: float1 5s infinite;
  animation: float1 5s infinite;
}
.card-1-back-2{
  background-image: url("http://data.xiyilab.com/web/main/static/理化生/物理模考装饰背景右侧.png");
  width: 17.3vw;
  height: 17.7vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  top:50vw;
  right: 6vw;
  -webkit-animation: float2 5s infinite;
  animation: float2 5s infinite;
}
.card-1-back-3{
  background-image: url("http://data.xiyilab.com/web/main/static/模考/椭圆7.png");
  width:3vw;
  height: 5vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  top:90vw;
  left: 0vw;
}
.card-1-back-4{
  -webkit-animation: float3 5s infinite;
  animation: float3 5s infinite;
  position: absolute;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/上下浮动.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 12vw;
  height: 10vw;
  left:8vw;
  top:70vw;
}
.card-1-back-5{
  position: absolute;
  animation: float4 5s infinite;
  -webkit-animation: float4 5s infinite;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/上下浮动1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 20vw;
  height: 21.5vw;
  right:6vw;
  top:90vw;
}
.card-1-back-6{
  position: absolute;
  animation: float5 5s infinite;
  -webkit-animation: float5 5s infinite;
  background-image: url("http://data.xiyilab.com/web/main/static/模考/上下浮动2.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 14.7vw;
  height: 19vw;
  left:10vw;
  bottom:0vw;
}
@keyframes float1 {
  0%{
    top:35vw;
  }
  50%{
    top:36vw;
  }
  100%{
    top:35vw;
  }
}
@-webkit-keyframes float1 {


  0%{
    top:35vw;
  }
  50%{
    top:36vw;
  }
  100%{
    top:35vw;
  }
}
@keyframes float3 {
  0%{
    top:70vw;
  }
  50%{
    top:71vw;
  }
  100%{
    top:70vw;
  }
}
@-webkit-keyframes float3 {

  0%{
    top:70vw;
  }
  50%{
    top:71vw;
  }
  100%{
    top:70vw;
  }
}
@keyframes float4 {
  0%{
    top:90vw;
  }
  50%{
    top:91vw;
  }
  100%{
    top:90vw;
  }
}
@-webkit-keyframes float4 {
  0%{
    top:90vw;
  }
  50%{
    top:91vw;
  }
  100%{
    top:90vw;
  }
}
@keyframes float5 {
  0%{
    bottom:0vw;
  }
  50%{
    bottom:1vw;
  }
  100%{
    bottom:0vw;
  }
}
@-webkit-keyframes float5 {
  0%{
    bottom:0vw;
  }
  50%{
    bottom:1vw;
  }
  100%{
    bottom:0vw;
  }
}
@keyframes float2 {
  0%{
    top:50vw;
  }
  50%{
    top:51vw;
  }
  100%{
    top:50vw;
  }
}
@-webkit-keyframes float2 {
  0%{
    top:50vw;
  }
  50%{
    top:51vw;
  }
  100%{
    top:50vw;
  }
}

.switch-btn-1{
  position: absolute;
  z-index: 999;
  top:5vw;
  left:30vw;
  width: 15vw;
  height: 3vw;
  background-color: white;
  border-radius: 4px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vw;
  font-size: 1.2vw;
  text-align: center;
  font-family: test;
  letter-spacing: 2px;
  cursor: pointer;
}
.switch-btn-1:hover{
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%),
  linear-gradient(
    #f9faff,
    #f9faff);
  background-blend-mode: normal,
  normal;
  color: #f9faff;
}
.switch-btn-2:hover{
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%),
  linear-gradient(
    #f9faff,
    #f9faff);
  background-blend-mode: normal,
  normal;
  color: #f9faff;
}
.active-btn{
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%),
  linear-gradient(
    #f9faff,
    #f9faff);
  background-blend-mode: normal,
  normal;
  color: #f9faff;
}
.switch-btn-2{
  cursor: pointer;
  position: absolute;
  z-index: 999;
  top:5vw;
  right:30vw;
  width: 15vw;
  height: 3vw;
  background-color: white;
  border-radius: 4px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vw;
  font-size: 1.2vw;
  text-align: center;
  font-family: test;
  letter-spacing: 2px;
}

.footer-img{
  width: 100vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/育见未来.png");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer-btn-group{
  margin-top: 2vw;
  width: 30vw;
  height: 1.8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.footer-btn{
  width: 6vw;
  font-weight: 100;
  font-size: 0.8vw;
  font-family: test;
  border: 1px white solid;
  color: white;
  background: transparent;
  line-height:1.8vw;
  text-align: center;
  cursor: pointer;
}
</style>
